import { render, staticRenderFns } from "./DifferentiatingBenefitsIntroSection.vue?vue&type=template&id=74937e3d"
import script from "./DifferentiatingBenefitsIntroSection.vue?vue&type=script&lang=ts"
export * from "./DifferentiatingBenefitsIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./DifferentiatingBenefitsIntroSection.vue?vue&type=style&index=0&id=74937e3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports